const actionType = {
    GET_ALL_REF_DATA_DD_CONFIGURATION_SUCCESS: 'GET_ALL_REF_DATA_DD_CONFIGURATION_SUCCESS',
    GET_ALL_REF_DATA_LOOKUP_DD_CONFIGURATION_SUCCESS: 'GET_ALL_REF_DATA_LOOKUP_DD_CONFIGURATION_SUCCESS',
    GET_ALL_REF_DATA_GROUP_DD_CONFIGURATION_SUCCESS: 'GET_ALL_REF_DATA_GROUP_DD_CONFIGURATION_SUCCESS',
    CLEAN_API_LOGGERS: 'CLEAN_API_LOGGERS',
    ADD_API_LOGGERS: 'ADD_API_LOGGERS',
};
export default actionType;
